/* RIVOR — theme behaviour. No dependencies, no framework.
   Everything here is an enhancement: with scripting off the variant select and
   the add-to-cart form still work as plain HTML. */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ header */

  var header = document.querySelector('[data-header]');
  if (header && header.hasAttribute('data-header-overlay')) {
    var solid = false;
    var onScroll = function () {
      var next = window.scrollY > 80;
      if (next !== solid) { solid = next; header.classList.toggle('is-solid', solid); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------- mobile navigation */

  var overlay = document.querySelector('[data-nav-overlay]');
  var openBtn = document.querySelector('[data-nav-open]');
  var closeBtn = document.querySelector('[data-nav-close]');

  function setNav(open) {
    if (!overlay || !openBtn) return;
    overlay.classList.toggle('is-open', open);
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('is-locked', open);
    if (open) {
      var first = overlay.querySelector('a, button');
      if (first) first.focus();
    } else {
      openBtn.focus();
    }
  }

  if (openBtn) openBtn.addEventListener('click', function () { setNav(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setNav(false); });

  document.addEventListener('keydown', function (e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') { setNav(false); return; }
    if (e.key !== 'Tab') return;
    var focusable = [].slice.call(overlay.querySelectorAll('a[href], button'));
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------- scroll-in reveals */

  var reveals = [].slice.call(document.querySelectorAll('.reveal'));
  if (reveals.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var group = el.parentElement ? [].slice.call(el.parentElement.querySelectorAll(':scope > .reveal')) : [];
          var index = group.indexOf(el);
          el.style.setProperty('--reveal-delay', (index > 0 ? index * 80 : 0) + 'ms');
          el.classList.add('is-in');
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

      reveals.forEach(function (el) {
        // Already in view on arrival: show it outright rather than fading the
        // first screen in after the page has painted.
        var box = el.getBoundingClientRect();
        if (box.top < window.innerHeight && box.bottom > 0) {
          el.classList.add('is-in');
          return;
        }
        io.observe(el);
      });

      // Last resort. If the observer never reports back, nothing is left invisible.
      window.setTimeout(function () {
        reveals.forEach(function (el) {
          if (el.classList.contains('is-in')) return;
          var box = el.getBoundingClientRect();
          if (box.top < window.innerHeight * 1.5) el.classList.add('is-in');
        });
      }, 2500);
    }
  }

  /* ---------------------------------------------------------- accordion */

  [].forEach.call(document.querySelectorAll('[data-accordion]'), function (root) {
    var triggers = [].slice.call(root.querySelectorAll('[data-accordion-trigger]'));

    function close(trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', 'false');
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      void panel.offsetHeight;
      panel.style.height = '0px';
    }

    function open(trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', 'true');
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      var done = function () { panel.style.height = 'auto'; panel.removeEventListener('transitionend', done); };
      if (reduceMotion) done(); else panel.addEventListener('transitionend', done);
    }

    triggers.forEach(function (trigger, i) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel) panel.style.height = trigger.getAttribute('aria-expanded') === 'true' ? 'auto' : '0px';

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        triggers.forEach(function (other) {
          if (other.getAttribute('aria-expanded') === 'true') close(other);
        });
        if (!isOpen) open(trigger);
      });

      trigger.addEventListener('keydown', function (e) {
        var move = { ArrowDown: 1, ArrowUp: -1 }[e.key];
        if (!move) return;
        e.preventDefault();
        triggers[(i + move + triggers.length) % triggers.length].focus();
      });
    });
  });

  /* ---------------------------------------------------------- cart count */

  function paintCount(count) {
    [].forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = '(' + count + ')';
    });
    [].forEach.call(document.querySelectorAll('[data-cart-label]'), function (el) {
      el.textContent = count === 1 ? 'Bag, 1 item' : 'Bag, ' + count + ' items';
    });
  }

  /* ------------------------------------------------------ product form */

  [].forEach.call(document.querySelectorAll('[data-product]'), function (root) {
    var json = root.querySelector('[data-variant-json]');
    if (!json) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var mediaMap = {};
    var mediaJson = root.querySelector('[data-variant-media]');
    if (mediaJson) { try { mediaMap = JSON.parse(mediaJson.textContent); } catch (e) { mediaMap = {}; } }

    var select = root.querySelector('[data-variant-select]');
    var options = [].slice.call(root.querySelectorAll('[data-option-position]'));
    var frames = [].slice.call(root.querySelectorAll('[data-media-id]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var status = root.querySelector('[data-add-status]');
    var form = root.querySelector('form');

    /* Option controls are radios inside a radiogroup, or toggle buttons in the
       colourway row. Read and write whichever state attribute each one declares. */
    function stateAttr(el) {
      return el.hasAttribute('aria-pressed') ? 'aria-pressed' : 'aria-checked';
    }

    function isOn(el) { return el.getAttribute(stateAttr(el)) === 'true'; }

    function setOn(el, on) {
      el.setAttribute(stateAttr(el), on ? 'true' : 'false');
      if (el.hasAttribute('aria-checked')) el.tabIndex = on ? 0 : -1;
    }

    function chosen() {
      var values = [];
      options.forEach(function (btn) {
        if (!isOn(btn)) return;
        values[Number(btn.getAttribute('data-option-position')) - 1] = btn.getAttribute('data-option-value');
      });
      return values;
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] != null && v.options[j] !== values[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function money(cents) {
      var value = (cents / 100).toLocaleString(document.documentElement.lang || 'en-GB',
        { minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 });
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'GBP' ? '£' : '') + value;
    }

    function showMedia(mediaId) {
      if (!frames.length) return;
      var target = null;
      frames.forEach(function (frame) {
        if (String(frame.getAttribute('data-media-id')) === String(mediaId)) target = frame;
      });
      if (!target) return;
      frames.forEach(function (frame) { frame.classList.toggle('is-active', frame === target); });
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-selected', String(thumb.getAttribute('data-thumb')) === String(mediaId) ? 'true' : 'false');
      });
    }

    function apply(variant) {
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (select) select.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        compareEl.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
        if (!compareEl.hidden) compareEl.textContent = money(variant.compare_at_price);
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (mediaMap[variant.id]) showMedia(mediaMap[variant.id]);
      if (status) status.textContent = '';

      // Keep the address bar honest, so the URL can be shared or reloaded.
      if (window.history.replaceState && root.getAttribute('data-product-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    function selectOption(position, value, focus) {
      var group = options.filter(function (b) { return b.getAttribute('data-option-position') === String(position); });
      group.forEach(function (btn) {
        var on = btn.getAttribute('data-option-value') === value;
        setOn(btn, on);
        if (on && focus) btn.focus();
      });
      var label = root.querySelector('.field-value[data-option-label="' + position + '"]');
      if (label) label.textContent = value;
      apply(match(chosen()));
    }

    options.forEach(function (btn) {
      var position = btn.getAttribute('data-option-position');
      var group = options.filter(function (b) { return b.getAttribute('data-option-position') === position; });

      btn.addEventListener('click', function () {
        selectOption(position, btn.getAttribute('data-option-value'), false);
      });

      btn.addEventListener('keydown', function (e) {
        var move = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (move) {
          e.preventDefault();
          var i = group.indexOf(btn);
          var next = group[(i + move + group.length) % group.length];
          selectOption(position, next.getAttribute('data-option-value'), true);
        } else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          selectOption(position, btn.getAttribute('data-option-value'), false);
        }
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-thumb')); });
    });

    /* Add to bag without a page load, falling back to a normal submit. */
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (!select || !select.value) return;
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        if (status) status.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (added) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                paintCount(cart.item_count);
                if (status) {
                  status.textContent = 'Added: ' + (added.variant_title || added.title) + '. ';
                  var link = document.createElement('a');
                  link.className = 'link';
                  link.href = '/cart';
                  link.textContent = 'View bag';
                  status.appendChild(link);
                }
              });
          })
          .catch(function () { form.submit(); })
          .then(function () { if (addBtn) addBtn.disabled = false; });
      });
    }

    apply(match(chosen()));
  });
})();
